<section
  class="ui-empty-state"
  [class.ui-empty-state-neutral]="isNeutral()"
  [class.ui-empty-state-info]="isInfo()"
  [class.ui-empty-state-success]="isSuccess()"
  [class.ui-empty-state-warning]="isWarning()"
  [class.ui-empty-state-danger]="isDanger()"
>
  <div class="ui-empty-state-icon" aria-hidden="true">
    <ng-content select="[uiStateIcon]" />
    <span class="ui-empty-state-icon-label">{{ iconLabel() }}</span>
  </div>
  <div class="ui-empty-state-copy">
    <h2 class="ui-empty-state-title">{{ title() }}</h2>
    @if (hasDescription()) {
      <p class="ui-empty-state-description">{{ description() }}</p>
    }
  </div>
  @if (hasAction()) {
    <ui-button size="sm" variant="secondary" (pressed)="handleActionSelected()">
      {{ actionLabel() }}
    </ui-button>
  }
</section>
